import { useCallback } from 'react';

import { replaceFeedbackTerminology } from '../utils/feedback-terminology';

export const useFeedbackTerminology = (): {
  replaceFeedbackTerminology: (text: string) => string;
} => {
  const replaceFeedbackTerminologyByUsageType = useCallback(
    (text: string) => replaceFeedbackTerminology(text),
    [],
  );

  return {
    replaceFeedbackTerminology: replaceFeedbackTerminologyByUsageType,
  };
};
